<style scoped >
.rounded { border-radius: 25px; }
.rounded-collapsed { border-radius: 25px 0px 0px; }
</style>
<template>
<v-dialog
  :fullscreen='$vuetify.breakpoint.xs'
  v-model="bottomsheet"
  max-width="600px" >

  <v-card >
    <!-- SS: {{spaceIds}} -->
      <v-card-title class='overline py-0 grey lighten-2' >
        <v-btn small icon
          @click='activeWindow=0'
          v-if='activeWindow===1'
          class='pa-0 ma-0' >
          <v-icon small >chevron_left</v-icon>
        </v-btn>
        Choose an appointment type
        <v-spacer></v-spacer>
        <v-btn small icon @click='bottomsheet=false'><v-icon small>close</v-icon></v-btn>
      </v-card-title>
      <v-list dark class='pa-0 ma-0' >
        <practitioner-list-item v-if='practitioner' :item='practitioner' />
      </v-list>
      <v-footer v-if='activeWindow > 0' class='pl-4' >{{selectedService.title}}</v-footer>

      <v-divider></v-divider>

      <v-card-text height='100%' >
        <v-window v-model="activeWindow" vertical touchless >
          <v-window-item :key="0" >
            <v-card flat class='rounded' >
              <v-list dense class="rounded" >
                <!-- {{$store.getters.spaces}} -->
                <template v-for='(service, index) in spaces' >
                  <!-- expandable -->
                  <v-list-tile class='grey lighten-2 py-1 mt-4 elevation-5'
                    @click='toggleService(service)'
                    :class="['staticClass', service.collapsed ? 'rounded' : 'rounded-collapsed']"
                    :key='`${index}-${service.id}`' >
                    <v-list-tile-action v-if='spaces && spaces.length > 1' >
                      <v-btn icon >
                        <v-icon v-if='service.collapsed === true' >expand_more</v-icon>
                        <v-icon v-else >expand_less</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-avatar >
                      <v-img
                        v-if='service.logo_picture'
                        :src='service.logo_picture' />
                      <v-icon v-else color='blue' >star_outline</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-text='service.title'>
                      </v-list-tile-title>
                      <v-list-tile-sub-title >
                        <span v-if='service.locations && service.locations.length === 1' >
                          <v-icon small >location_on</v-icon>
                          {{ service.locations[0].name }}
                        </span>

                        <v-chip v-if='service.role'
                          :color='roleColor(service.role)' dark outline class='v-chip--x-small ml-0' >
                          {{service.role}}
                        </v-chip>

                        <v-tooltip v-if='service.members && service.members.length > 1' bottom >
                          <template v-slot:activator="{ on }">
                            <v-chip color='info' dark outline
                              v-on='on'
                              class='v-chip--x-small ml-0' >
                              <!-- <v-icon left >group</v-icon> -->
                              shared space
                            </v-chip>
                          </template>
                          <span>All members of this space will be able to see this appointment</span>
                        </v-tooltip>
                        <v-tooltip v-else bottom >
                          <template v-slot:activator="{ on }">
                            <v-chip color='info' dark outline
                              v-on='on'
                              class='v-chip--x-small ml-0' >
                              Private
                            </v-chip>
                          </template>
                          <span>You are currently the only member of this space</span>
                        </v-tooltip>

                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action

                      class='mr-5' >
                      <v-tooltip bottom >
                        <template v-slot:activator="{ on }">
                          <v-btn icon
                            :href = "`${LINKS.SETTINGS_SPACES}${service.id}`"
                            :disabled = "!canManageSpace(service)"
                            target = "_blank"
                            v-on = 'on' ><v-icon>open_in_new</v-icon></v-btn>
                        </template>
                        <span>Manage this space</span>
                      </v-tooltip>
                    </v-list-tile-action>
                    <v-btn small fab top right absolute
                      color='primary'
                      v-if='canAddProduct(service)'
                      @click='selectedService=service;activeWindow = 1' >
                      <v-icon small >add</v-icon></v-btn>
                  </v-list-tile>

                  <v-divider v-if='!service.collapsed' :key='`div-${service.id}`' />

                  <template v-if='service.collapsed !== true' >

                    <!-- single location -->
                    <v-card
                      v-if='service.locations && service.locations.length <= 1'
                      :key='`noloc-${service.id}`' >

                      <template
                        v-for='(product, index) in getProducts(practitioner.id, service.id, null)' >
                        <!-- @click='setSelected(service, location, product.id)' > -->
                        <v-list-tile
                          v-if='product.archived !== true'
                          :key="`p-${product.id}-${service.id}-noloc-${index}`"
                          @click='setSelected(service, service.locations, product.id)' >
                          <v-list-tile-content>
                            <v-list-tile-title v-text="product.title" />
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider
                          :key='`div-${product.id}-noloc-${service.id}-${practitioner.id}-${index}`' />
                      </template>
                      <v-card-actions v-if='service.locations.length === 0' >
                          <span class='ml-2'>No locations defined.</span>
                          <v-spacer/>
                          <v-btn small flat
                            v-if='canAddProduct(service)'
                            @click='gotoLocation(service)' >Create one?</v-btn>
                      </v-card-actions>
                      <template v-else >
                        <v-card-actions v-if='getProducts(practitioner.id, service.id, null).length === 0' >
                            <span class='ml-2'>No appointment types defined.</span>
                            <v-spacer/>
                            <v-btn small flat
                              v-if='canAddProduct(service)'
                              @click='selectedService=service;activeWindow = 1' >Create one?</v-btn>
                        </v-card-actions>
                      </template>
                    </v-card>

                    <!-- multiple locations -->
                    <v-card v-else
                      v-for='location in service.locations'
                      :key='`${service.id}-${location.id}`' >
                        <v-card-title
                          @click='togglelocation(location)'
                          :key='`loc-${location.id}`'
                          class='pl-0 py-0 grey lighten-5' >
                          <v-btn
                            v-if='service.locations.length > 1' icon small >
                              <v-icon small v-if='location.collapsed === true' >expand_more</v-icon>
                              <v-icon small v-else >expand_less</v-icon>
                          </v-btn>
                          <v-icon color='primary' >location_on</v-icon>
                          <strong class='overline' v-text='location.name' />
                          <v-spacer></v-spacer>
                          <v-chip
                            outline small
                            v-if='location.collapsed === true' color='primary' class='caption' >
                            {{ getProducts(practitioner.id, service.id, location.id).length }}
                          </v-chip>
                        </v-card-title>
                        <v-divider />
                        <template v-if='location.collapsed !== true' >
                          <template
                            v-for='(product, index) in getProducts(practitioner.id, service.id, location.id)' >
                            <v-list-tile
                              v-if='product.archived !== true'
                              :key="`p-${product.id}-${service.id}-${location.id}-${index}`"
                              @click='setSelected(service, location, product.id)' >
                              <v-list-tile-content>
                                <v-list-tile-title v-text="product.title" />
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-divider
                              :key='`div-${product.id}-${location.id}-${service.id}-${practitioner.id}-${index}`' />
                          </template>
                          <v-card-actions v-if='getProducts(practitioner.id, service.id, location.id).length === 0' >
                              <span class='ml-2'>No appointment types defined.</span>
                              <v-spacer/>
                              <v-btn small flat
                                v-if='canAddProduct(service)'
                                @click='selectedService=service;activeWindow = 1' >Create one?</v-btn>
                          </v-card-actions>
                        </template>
                    </v-card>
                  </template>

                  <v-footer v-if='service.collapsed !== true' >
                    <v-spacer/>
                    <v-btn small outline
                      @click='selectedService=service;activeWindow="location"'
                      color='primary' class='pa-1' >
                      <v-icon small >add</v-icon> New location
                    </v-btn>
                  </v-footer>
                  <v-divider/>

                </template>

              </v-list>
              <v-card-actions class='mt-3' >
                <v-btn small outline block
                  @click='activeWindow="space"'
                  color='primary' >
                  <v-icon small >add</v-icon> New space
                </v-btn>
              </v-card-actions>
              <v-divider />
              <v-card-actions class='mt-3' >
                <v-btn small flat text @click='bottomsheet=false'>
                  cancel
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn @click='refresh' :loading='getMeReq.loading' small outline outlined color='primary' >
                  <v-icon small >replay</v-icon> Refresh
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-window-item>
          <v-window-item :key='1'>
            <request-status :request='saveRequest' />
            <appointment-type
              @cancel='activeWindow = 0'
              @save='addProduct'
              @add:location='gotoLocation(selectedService)'
              :practitioner='practitioner'
              :service='selectedService'
              :withTitle='false'
              :withCancel='true'
              :loading='saveRequest.loading' >
            </appointment-type>
          </v-window-item>

          <v-window-item :key='2' class='text-xs-center' >
            <v-icon :size='72' color='success' >check_circle</v-icon>
            <h3 class='subheading mb-4' >Product added</h3>
            <template v-if='globalInitRequestLoading' >
              <v-progress-circular indeterminate color='amber' class='pb-4' >
              </v-progress-circular> Updating profile
            </template>
            <div>
            <v-btn class='rounded px-5 mt-4' color='success' @click='activeWindow=0' >Done</v-btn>
            </div>
          </v-window-item>

          <v-window-item value='space' >
            <v-card flat >
              <v-card-title class='subtitle-1 overline' >
                <v-btn icon small @click='activeWindow=0' >
                  <v-icon small>arrow_back</v-icon>
                </v-btn>
                Add a new space
                <v-spacer/>
                <v-btn
                  :href="LINKS.SETTINGS_SPACES"
                  small outline color='primary' >
                  Manage spaces
                  <v-icon small class='ml-2' >open_in_new</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider/>
              <space-wizard
                @cancel="activeWindow=0"
                @success="spaceCreated" >

              </space-wizard>
            </v-card>
          </v-window-item>

          <v-window-item value='location' >
            <v-card flat >
              <v-card-title class='subtitle-1 overline' >
                <v-btn icon small @click='activeWindow=0' >
                  <v-icon small>arrow_back</v-icon>
                </v-btn>
                Add a new location
                <v-spacer/>
                <v-btn
                  :href="`${LINKS.SETTINGS_SPACES}--/locations`"
                  small outline color='primary' >
                  Manage locations
                  <v-icon small class='ml-2' >open_in_new</v-icon>
                </v-btn>
              </v-card-title>
              <!-- @success="spaceCreated" -->
              <location-wizard v-if='selectedService && selectedService.id'
                :space-id='selectedService.id'
                :space='selectedService'
                :success-steps='locationSuccessSteps'
                :touch='touchLocation'
                @cancel="activeWindow=0" />
            </v-card>
          </v-window-item>
        </v-window>

      </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
import {
  GET_ME_REQ,
  LINKS
} from '@/store/constants'
import AppointmentType from '@/components/pages/settings/locations/AppointmentTypes'
import PractitionerListItem from '@/components/listitems/PractitionerListItem.vue'
import SpaceWizard from '@/components/wizards/Space/index.vue'
import LocationWizard from '@/components/wizards/Location/index.vue'
import {mapGetters} from 'vuex'
import Vue from 'vue'

// const WINDOWS = {
//   CHOOSE: 0,
//   NEW: 1,

// }

export default {
  name: 'ProductSheet',
  components: {
    AppointmentType,
    PractitionerListItem,
    SpaceWizard,
    LocationWizard
  },
  props: {
    label: { type: String, default: 'Choose a product' },
    placeholder: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    value: { type: Object, default: () => { return {} } },
    service: { type: Object, default: () => { return {} } },
    practitioner: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      bottomsheet: false,
      activeWindow: 0,
      createReq: 'products-update-save-request',
      selectedService: null,
      searchString: '',
      touchLocation: 0,
      touchSpace: 0,
      LINKS: LINKS
    }
  },
  mounted () {
    if (!this.practitioner && !this.practitioner.id) {
      this.$emit('update:practitioner', this.me)
    }
  },
  watch: {
    visible () {
      this.bottomsheet = this.visible
    },
    saveRequestStatus () {
      if (this.saveRequestStatus === 201) {
        this.activeWindow = 2
        this.refresh()
      }
    },
    // meRequestStatus () {
    //   if (this.meRequestStatus === 200) {
    //     this.activeWindow = 0
    //   }
    // },
    service: {
      immediate: true,
      handler () {
        if (this.service) { this.selectedService = this.service }
      }
    }
  },
  methods: {
    // isNewService (index, item, items) {
    //   let service = item.service
    //   if (index === 0) { return true }
    //   if (service && service.address && items[index - 1].service.address) {
    //     return service.address.name !== items[index - 1].service.address.name
    //   }
    //   return false
    // },
    toggleService (service) {
      if (service.collapsed === true) {
        Vue.set(service, 'collapsed', false)
      } else {
        Vue.set(service, 'collapsed', true)
      }
    },
    togglelocation (loc) {
      if (loc.collapsed === true) {
        Vue.set(loc, 'collapsed', false)
      } else {
        Vue.set(loc, 'collapsed', true)
      }
    },
    setSelected (service, location, productId) {
      if (Array.isArray(location) && location.length === 1) {
        location = location[0]
      }
      let product = this.$store.getters.getProductById(productId)
      let data = { service, location, product }
      this.$emit('selectedservice', data)
    },
    canAddProduct (space) {
      let isOwner = (space.role === 'Owner')
      let isMyself = (this.practitionerId === this.meId)
      if (isOwner) { return true }
      if (isMyself) { return true }
      return false
    },
    canManageSpace (space) {
      let isOwner = (space.role === 'Owner')
      return isOwner
    },
    refresh () {
      this.getMe()
      this.getLookups()
    },
    addProduct (product) {
      if (this.selectedService.service) {
        product.service = this.selectedService.service.id
      } else {
        product.service = this.selectedService.id
      }
      if (this.practitionerId) {
        product.practitioner = this.practitionerId
      }

      // if (product.locations) {
      //   product.locations = product.locations.map((loc) => {
      //     if (loc && loc.id) { return loc.id }
      //     return loc
      //   })
      // }

      product.order = 100 // add it to the end of the list
      let data = JSON.stringify(product)
      this.$appointmentguru
        .resource('practitioner.services.products')
        .id(this.createReq)
        .create(data)
    },
    spaceCreated () {
      this.refresh()
    },
    gotoLocation (service) {
      this.touchLocation++
      this.selectedService = service
      this.activeWindow = 'location'
    },
    locationCreated () {
      this.refresh()
    }
  },
  computed: {
    ...mapGetters(['services', 'getProducts', 'getSpacesByPractitionerId']),
    saveRequest () {
      return this.$store.getters.getRequestById(this.createReq, true)
    },
    practitionerId () {
      return this.getObjectPath(this.practitioner, 'id', null)
    },
    spaces () {
      if (this.practitionerId) {
        return this.getSpacesByPractitionerId(this.practitionerId)
        // if (spaces) { return spaces.map((space) => { return space.id }) }
      }
      return []
    },
    saveRequestStatus () {
      return this.saveRequest.status
    },
    meRequest () {
      return this.$store.getters.getRequestById(GET_ME_REQ, true)
    },
    meRequestStatus () {
      return this.meRequest.status
    },
    services () {
      let services = this.services
      let serviceLookup = []
      for (let service of services) {
        for (let product of service.products) {
          let hidden = false
          if (this.searchString) {
            if (product.title.toLowerCase().indexOf(this.searchString.toLowerCase()) === -1) {
              hidden = true
            }
          }
          if (!hidden) {
            serviceLookup.push({
              product: product,
              service: service,
              value: product.id,
              text: product.title
            })
          }
        }
      }
      return serviceLookup
    },
    locationSuccessSteps () {
      let spaceId = null
      let vm = this
      if (this.selectedService) {
        spaceId = this.selectedService.id
      }
      return [
        {
          click: () => {
            console.log('touch me on my location')
            vm.touchLocation++
          },
          events: {},
          text: 'Add another'
        },
        {
          click: () => {},
          events: {},
          attrs: {
            href: vm.LINKS.SETTINGS_SPACES + spaceId + '/locations',
            target: '_blank'
          },
          text: 'Edit further',
          icon: 'open_in_new'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductSheet.vue?26791da9